import type { DashboardUser } from '../auth/auth-adapter'
import { getEnvironment } from '../../lib/environment'
import { createApiClient } from '../../services/api/client'
import {
  campaignSettingsResponseSchema,
  campaignSettingsUpdateSchema,
  type CampaignSettingsResponse,
  type CampaignSettingsUpdate,
} from './campaign-settings-contracts'

export type CampaignSettingsRepository = {
  getSettings: (tenantId: string) => Promise<CampaignSettingsResponse>
  updateSettings: (
    tenantId: string,
    update: CampaignSettingsUpdate
  ) => Promise<CampaignSettingsResponse>
}

export function createCampaignSettingsRepository({
  getUser,
  baseUrl = getEnvironment().onboardingApiBaseUrl,
  fetchImplementation,
}: {
  getUser: () => DashboardUser | null
  baseUrl?: string
  fetchImplementation?: typeof fetch
}): CampaignSettingsRepository {
  const client = createApiClient({ baseUrl, getUser, fetchImplementation })
  return {
    getSettings(tenantId) {
      return client.request('/v1/settings/campaigns', {
        method: 'POST',
        body: { tenantUid: tenantId },
        responseSchema: campaignSettingsResponseSchema,
      })
    },
    updateSettings(tenantId, update) {
      const parsed = campaignSettingsUpdateSchema.parse(update)
      return client.request('/v1/settings/campaigns', {
        method: 'PUT',
        body: { tenantUid: tenantId, ...parsed },
        responseSchema: campaignSettingsResponseSchema,
      })
    },
  }
}
